import {AgencyRepository} from "../../../repositories/AgencyRepository.ts";
import {Agency, AgencyFormData} from "../../entities/Agency.ts";

export class UpdateAgencyUseCase {
    constructor(private readonly agencyRepository: AgencyRepository) {

    }
    async execute(id: string, data: AgencyFormData): Promise<Agency> {
        return this.agencyRepository.updateAgency(id, data);
    }
}
